import React from "react";
import { ToolbarSkeleton } from "../../../account/ToolbarSkeleton";
import { LSResultItemSkeletonList } from "./LSResultItemSkeletonList";

export interface LSResultItemListWithToolbarSkeletonProps {
  pageSize: number;
  hideCheckbox?: boolean;
  hideActions?: boolean;
}

export const LSResultItemListWithToolbarSkeleton: React.FC<
  LSResultItemListWithToolbarSkeletonProps
> = ({ pageSize, hideCheckbox, hideActions = true }) => {
  return (
    <>
      <ToolbarSkeleton hideCheckbox={hideCheckbox} hideActions={hideActions} />
      <LSResultItemSkeletonList
        pageSize={pageSize}
        hideCheckbox={hideCheckbox}
        hideActions={hideActions}
      />
    </>
  );
};
